import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import IllustrationHps from '../../assets/illustration-hps';
import IllustrationMps from '../../assets/illustration-mps';
import IllustrationIpsMobile from '../../assets/illustration-ips-mobile';
import IllustrationIpsDesktop from '../../assets/illustration-ips-desktop';
import { ORDER_CHANNEL_KEY } from '../../types/orderChannels';
import { PartnerWizardComponent } from '../../cwc-partner-wizard';

/**
 * Definition of  parameters that the template needs to work.
 */
interface PartnerWizardChannelsTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: PartnerWizardComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const PartnerWizardChannelsTemplate: FunctionalComponent<PartnerWizardChannelsTemplateProps> = ({ controller }) => {
  const channels = controller.getOrderChannels();

  return (
    <div class="channels">
      {channels.software?.type === ORDER_CHANNEL_KEY.DESKTOP_SOFTWARE && (
        <div class="channel-box channel-hps">
          <div class="channel-headline">
            <hgroup>
              <h4>{controller.textChannelsHpsHeadline}</h4>

              {controller.textChannelsHpsSubline && <h5>{controller.textChannelsHpsSubline}</h5>}
            </hgroup>

            <IllustrationHps />
          </div>

          <div class="selling-points" innerHTML={controller.textChannelsHpsSellingPoints} />

          <a
            onClick={() =>
              controller.onSoftwareLinkClicked.emit({
                keyAccount: controller.getCurrentKeyAccount(),
                external: controller.getCurrentKeyAccount() !== controller.keyAccount,
                type: channels.software.type,
                os: channels.software.os,
                target: channels.software.link,
              })
            }
            href={channels.software.link}
            class="button-strong button-order-software"
            part={'modal-button-order-software-hps'}
            data-keyaccount={controller.getCurrentKeyAccount()}
          >
            {controller.textChannelsHpsButton}
          </a>
        </div>
      )}

      {channels.software?.type === ORDER_CHANNEL_KEY.MOBILE_SOFTWARE && (
        <div class="channel-box channel-mps">
          <div class="channel-headline">
            <hgroup>
              <h4>{controller.textChannelsMpsHeadline}</h4>

              {controller.textChannelsMpsSubline && <h5>{controller.textChannelsMpsSubline}</h5>}
            </hgroup>

            <IllustrationMps />
          </div>

          <div class="selling-points" innerHTML={controller.textChannelsMpsSellingPoints} />

          <a
            onClick={() =>
              controller.onSoftwareLinkClicked.emit({
                keyAccount: controller.getCurrentKeyAccount(),
                external: controller.getCurrentKeyAccount() !== controller.keyAccount,
                type: channels.software.type,
                os: channels.software.os,
                target: channels.software.link,
              })
            }
            href={channels.software.link}
            class="button-strong button-order-software"
            part={'modal-button-order-software-mps'}
            data-keyaccount={controller.getCurrentKeyAccount()}
          >
            {controller.textChannelsMpsButton}
          </a>
        </div>
      )}

      {channels.online && (
        <div class="channel-box channel-online">
          <div class="channel-headline">
            <hgroup>
              <h4>{controller.textChannelsOnlineHeadline}</h4>

              {controller.textChannelsOnlineSubline && <h5>{controller.textChannelsOnlineSubline}</h5>}
            </hgroup>

            <IllustrationIpsMobile class="hide-on-desktop" />
            <IllustrationIpsDesktop class="hide-on-mobile" />
          </div>

          <div class="selling-points" innerHTML={controller.textChannelsOnlineSellingPoints} />

          <a
            onClick={() =>
              controller.onEditorLinkClicked.emit({
                keyAccount: controller.getCurrentKeyAccount(),
                external: controller.getCurrentKeyAccount() !== controller.keyAccount,
                target: channels.online,
              })
            }
            href={channels.online}
            class="button-strong button-order-online"
            part={'modal-button-order-online'}
            data-keyaccount={controller.getCurrentKeyAccount()}
          >
            {controller.textChannelsOnlineButton}
          </a>
        </div>
      )}
    </div>
  );
};

export default PartnerWizardChannelsTemplate;
